import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectOfferId, selectUser } from 'shared/selectors';
import { getEarlyAccessPaywallMicrofrontend } from 'shared/services/getEarlyAccessPaywallMicrofrontend';

import { EarlyAccessPaywallProvider as Provider } from '../../../packages/EarlyAccessPaywall';
import { ESource } from '../../../packages/EarlyAccessPaywall/shared/types/context';
import { useApplicationContext } from '../ApplicationContext';

export const EarlyAccessPaywallProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const context = useApplicationContext();
  const fetchManifest = React.useCallback(async () => getEarlyAccessPaywallMicrofrontend(context), [context]);
  const user = useSelector(selectUser);
  const isAuthenticated = !!user?.isAuthenticated;
  const offerId = useSelector(selectOfferId);

  const params = {
    isAuthenticated,
    source: ESource.Card,
    offerId,
  };

  return (
    <Provider fetchManifest={fetchManifest} params={params}>
      {children}
    </Provider>
  );
};
